import { render, staticRenderFns } from "./stulist.vue?vue&type=template&id=7963eb91&scoped=true&"
import script from "./stulist.vue?vue&type=script&lang=js&"
export * from "./stulist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963eb91",
  null
  
)

export default component.exports